/**
 * Created by francesco on 22/12/17.
 */
import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({name: 'safeHtml'})
export class SafeHtmlPipe {
	constructor(private sanitizer: DomSanitizer) {
	}

	transform(html) {
		const safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(html);
		return safeResourceUrl;
	}
}
